/* eslint-disable no-console */
const logWarn = window.console && console.warn ? (
  (...args/*, { cause = null, tags } = {}*/) => {
    console.warn(...args);
  }
) : (
  () => {}
);

export default logWarn;



// WEBPACK FOOTER //
// ./src/lib/logger/warn.js